import { parseISO, format, isValid } from 'date-fns';

export function normalizeDate(dateString: string | Date): Date {
  try {
    // If it's already a Date object, use it directly
    if (dateString instanceof Date) {
      if (!isValid(dateString)) {
        console.warn('Invalid date object provided, using current date');
        return new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate(),
          12, 0, 0, 0
        );
      }
      return new Date(
        dateString.getFullYear(),
        dateString.getMonth(),
        dateString.getDate(),
        12, // noon local time to avoid timezone issues
        0,
        0,
        0
      );
    }

    // Handle null or undefined
    if (!dateString) {
      console.warn('No date provided, using current date');
      return new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        12, 0, 0, 0
      );
    }

    // Parse the date string
    let date;
    try {
      date = parseISO(dateString);
    } catch (err) {
      console.warn('Failed to parse date string, using current date');
      return new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        12, 0, 0, 0
      );
    }
    
    if (!isValid(date)) {
      console.warn('Invalid date string provided, using current date');
      return new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        12, 0, 0, 0
      );
    }

    // Create a new date at noon local time to avoid timezone issues
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      12, // noon local time
      0,
      0,
      0
    );
  } catch (error) {
    console.error('Error normalizing date:', error);
    // Return current date as fallback instead of throwing
    return new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      12,
      0,
      0,
      0
    );
  }
}

export function formatDateForInput(date: Date): string {
  try {
    if (!date || !isValid(date)) {
      console.warn('Invalid date object for input formatting, using current date');
      return format(new Date(), 'yyyy-MM-dd');
    }
    return format(date, 'yyyy-MM-dd');
  } catch (error) {
    console.error('Error formatting date:', error);
    return format(new Date(), 'yyyy-MM-dd');
  }
}